/** @format */

import {ReactNode} from 'react';

import {CellContext} from '@tanstack/react-table';

import {Typography} from '@mui/material';

import {toStr} from 'helpers/stringHelpers';

import {TanStackTableData, TanStackTableValue} from '../types';

const getValue = (info: CellContext<TanStackTableData, TanStackTableValue>): ReactNode | string => {
  const value = info.getValue();

  if (typeof value === 'string' || typeof value === 'number') {
    return <Typography>{value}</Typography>;
  }

  return toStr(value);
};

export {getValue};
